import { normalizeMouseControl, type MouseControlValue } from '@dental-ui/shared/consts';

/**
 * Copied from the legacy DentalUI project; represents per-user preferences.
 */
export class UserSettingsDto {
  id?: string | null = null;
  userId?: string;
  dateFormat?: string;
  dentalNotation?: string;
  fileFormat?: string;
  language?: string;
  appType?: number;
  timeFormat?: string;
  timeZone?: string;
  currency?: string;
  theme?: string;
  /** MouseControlEnum string: "Default" | "Exocad" | "3Shape" */
  mouseControl?: MouseControlValue;

  // Notification
  isEpostaNotification?: boolean;
  isSmsNotification?: boolean;
  isMarketingEposta?: boolean;

  modifiedBy?: number;
  isDeleted = false;

  setData(data: Partial<UserSettingsDto> | Record<string, unknown>): void {
    const raw = data as Record<string, unknown>;
    const partial = data as Partial<UserSettingsDto>;
    const pick = <T>(camel: keyof UserSettingsDto, pascal: string): T | undefined => {
      const fromCamel = partial[camel];
      if (fromCamel !== undefined && fromCamel !== null && fromCamel !== '') {
        return fromCamel as T;
      }
      const fromPascal = raw[pascal];
      if (fromPascal !== undefined && fromPascal !== null && fromPascal !== '') {
        return fromPascal as T;
      }
      return (fromCamel ?? fromPascal) as T | undefined;
    };

    if (partial.id !== undefined || raw['Id'] !== undefined) this.id = pick('id', 'Id');
    if (partial.userId !== undefined || raw['UserId'] !== undefined) this.userId = pick('userId', 'UserId');
    if (partial.dateFormat !== undefined || raw['DateFormat'] !== undefined) {
      this.dateFormat = pick('dateFormat', 'DateFormat');
    }
    if (partial.dentalNotation !== undefined || raw['DentalNotation'] !== undefined) {
      this.dentalNotation = pick('dentalNotation', 'DentalNotation');
    }
    if (partial.fileFormat !== undefined || raw['FileFormat'] !== undefined) {
      this.fileFormat = pick('fileFormat', 'FileFormat');
    }
    if (partial.language !== undefined || raw['Language'] !== undefined) {
      this.language = pick('language', 'Language');
    }
    if (partial.appType !== undefined || raw['AppType'] !== undefined) {
      this.appType = pick('appType', 'AppType');
    }
    if (partial.timeFormat !== undefined || raw['TimeFormat'] !== undefined) {
      this.timeFormat = pick('timeFormat', 'TimeFormat');
    }
    if (partial.timeZone !== undefined || raw['TimeZone'] !== undefined) {
      this.timeZone = pick('timeZone', 'TimeZone');
    }
    if (partial.currency !== undefined || raw['Currency'] !== undefined) {
      this.currency = pick('currency', 'Currency');
    }
    if (partial.theme !== undefined || raw['Theme'] !== undefined) {
      this.theme = pick('theme', 'Theme');
    }

    if ('mouseControl' in partial || 'MouseControl' in raw) {
      // API null dönerse oturumda Default tutulur (SET_MOUSE_PRESET için)
      this.mouseControl = normalizeMouseControl(partial.mouseControl ?? raw['MouseControl']);
    }

    if (partial.isEpostaNotification !== undefined) this.isEpostaNotification = partial.isEpostaNotification;
    if (partial.isSmsNotification !== undefined) this.isSmsNotification = partial.isSmsNotification;
    if (partial.isMarketingEposta !== undefined) this.isMarketingEposta = partial.isMarketingEposta;
    if (partial.modifiedBy !== undefined) this.modifiedBy = partial.modifiedBy;
    if (partial.isDeleted !== undefined) this.isDeleted = partial.isDeleted;
  }

  clear(): void {
    this.id = null;
    this.userId = undefined;
    this.dateFormat = undefined;
    this.dentalNotation = undefined;
    this.fileFormat = undefined;
    this.language = undefined;
    this.appType = undefined;
    this.timeFormat = undefined;
    this.timeZone = undefined;
    this.currency = undefined;
    this.theme = undefined;
    this.mouseControl = undefined;
    this.isEpostaNotification = undefined;
    this.isSmsNotification = undefined;
    this.isMarketingEposta = undefined;
    this.modifiedBy = undefined;
    this.isDeleted = false;
  }
}
